import { useSelector } from "react-redux";
import { selectUserById } from "./usersSlice";
import { selectAllPosts, selectPostById, selectPostsByUser } from "../posts/postsSlice";

import React from 'react'
import { useParams, Link } from "react-router-dom";

const UserPage = () => {
  const { userId } = useParams()
  const user = useSelector(state => selectUserById(state, Number(userId)));

  const postsForUser = useSelector(state => selectPostsByUser(state, Number(userId)))

  const postsTitles = postsForUser.map((post) => (
    <li key={post.id}>
      <Link to={`/post/${post.id}`}>{post.title}</Link>
    </li>
  ))
    
  return (
    <section>
      <h2>{user?.name}</h2>
      <p>{user?.presentation}</p>
      <ol>{postsTitles}</ol>
    </section>
  )
}

export default UserPage